/**
 * Created by Miguel on 23/05/2017
 */
import { Component,Input, OnInit, ViewChild,ChangeDetectionStrategy, ViewEncapsulation  } from '@angular/core';
import { THROW_IF_NOT_FOUND } from '@angular/core/src/di/injector';
import { DomSanitizer,  SafeResourceUrl , SafeHtml } from '@angular/platform-browser';
import { AppDataService }  from '../../services/app-data.service';
import { TranslationService } from '../../services/translation.service';

//teleview
declare var $ : any;
declare const window: any;
declare var Swal : any;
declare var Sketchfab;
declare var google:any;
@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    selector : 'youtube-component',
    templateUrl:'youtube.component.html',
})
export class YoutubeComponent implements OnInit {

  public api;
  public videoCall='';
  public streamToClose
  public isMobile;
  public bigStream=false;
  public conference=true;
  public setVolume=null;
  public muted=false;

  public youtube=false;
  public localGame=false;
  public localLink='';
  public youtubeLink='';
  public matterport=false;
  public matterportLink='';
  public streetView=false;
  public sketchfab=false;
  public panorama=null
  public myPosition;

  public sketchclient;
  public sketchapi;

public max=false;
public min=false;
public close=false;

  public mpSdk;
  public iframe;
  public shouldCover=true;
  @Input() mobile: boolean;
  public iframeVolume;
  public sliderVolume;
  public sweep
  public matterportInit=false;
  public i=1;

  constructor( public _sanitizer: DomSanitizer, public _appData : AppDataService,public translate: TranslationService) {
  }
  public ngOnDestroy() {

  }
  
  // within a window load,dom ready or something like that place your:
  componentDidMount() {

  }
  public ngOnInit() : any {

  }
  public initStreetView(){
    let url=this._appData.stream;

    let idx=url.indexOf('@')
    let latStr=url.substring(idx+1)
    idx=latStr.indexOf(',')
    let lat=Number(latStr.substring(0,idx));
    let lonStr=latStr.substring(idx+1);
    idx=latStr.indexOf(',')
    let lng=Number(lonStr.substring(0,idx));

    let doc=document.getElementById("streetViewDesk") as HTMLElement
    if (doc){
      const fenway = { lat: lat, lng: lng };
      this.panorama = new google.maps.StreetViewPanorama(
        doc,
        {
          position: fenway,
          pov: {
            heading: 34,
            pitch: 10,
          },
        })
  
    }

  }
  public async init() {
  //  setTimeout(()=>{

  }
  public sendIframeMessage(messageKind){
    var iframe = document.getElementById('gameFrame');
    if (iframe == null) return;
    var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
    iWindow.postMessage(messageKind, "*");
  }


  public maximizeScreen(){
    let mheight = window.screen.availHeight;
    let mwidth = window.screen.availWidth;       
    let width=mwidth*60/100;
    let height=mheight*60/100;
    let top=mheight*0.1
    let left=mwidth*0.1
    let link=this.youtubeLink;
    window.open(link,
        'targetWindow',
        'toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes,width='+width+',height='+height+',top='+top+',left='+left                    );                   

    /*
      this.min=false;
        if (!this.max){
          $(".popup").css("inset",'5px 5px 5px 5px');
          $("#popup-iframe-box").css("height",'');
          $("#popup-iframe-box").addClass("ratio-16x9");
          $('#minimize-popup-fix').css("visibility",'visible')

        }
        else{
          $(".popup").css("inset",'0px 0px 80vh 65vw');
          $("#popup-iframe-box").css("height",'');
          $("#popup-iframe-box").addClass("ratio-16x9");
          $('#minimize-popup-fix').css("visibility",'visible')

        }
        this.max=!this.max;*/
  }
  public minimizeScreen(){
    this.max=false;
        if (!this.min){
          $(".popup").css("inset",'5px 5px 95vh 65vw');
          $("#popup-iframe-box").css("height",'1px');
          $("#popup-iframe-box").removeClass("ratio-16x9");
          $('#minimize-popup-fix').css("visibility",'hidden')

        }
        else{
//          $(".popup").css("inset",'92vh 5px 5px 40vw');
          $(".popup").css("inset",'5px 5px 90vh 65vw');
          $("#popup-iframe-box").addClass("ratio-16x9");
          $("#popup-iframe-box").css("height",'');

          $('#minimize-popup-fix').css("visibility",'visible')
          

        }
        this.min=!this.min;
  }
  public closeScreen(){
    this._appData.streamClose=true;
//    this.streamToClose=this._appData.stream
    $(".popup").toggle(300)
//    this.fixMuteYoutube();
  }
  public showScreen(){
      this.min=false;
      this.max=false;
      this.localGame=true;
      this.localLink=this._appData.stream;
      let w=window.innerWidth-window.innerWidth/3;//-300;
      let h=window.innerHeight-window.innerHeight/2//-300;
      $(".popup").css("inset",'0px 0px 80vh 65vw');
      if (this._appData.streamClose){
        this._appData.streamClose=false;
        this.setGameWatchingVideo('unMute',[])
        $(".popup").toggle(300)
      }
  
    
  }
  public reload() : any{

    //part 1 of reload...decide what will be displayed on the video screen
    if (!this._appData.stream) {
      this._appData.stream=this._appData.room.video;
    }
    if (!this._appData.event['videoDesk']){this._appData.event['videoDesk']=''}

    if (this._appData.event['videoDesk'].indexOf(this._appData.stream)==-1){
      if (this._appData.stream){
        this._appData.event['videoDesk']=this._appData.stream;
      }
    }
    if (this._appData.stream.indexOf('youtube')>0){
      this.youtube=true;
      $('#matterportViewDesk').css('visibility','hidden')
      $('#youtubeViewDesk').css('visibility','visible')
      $('#streetViewDesk').css('visibility','hidden')

      let newLink=this._appData.stream+'?autoplay=1&enablejsapi=1';
      if (this.youtubeLink!=newLink){//if link changed
        this.youtubeLink=newLink
        this.setGameWatchingVideo('playVideo',[])
        setTimeout(()=>{
          this.setGameWatchingVideo('unMute',[])
          let iframe  = document.getElementById('youtubeViewDesk') 
          iframe.style.height = '90%';
        },1000)
  
      }
    }
    else if (this._appData.stream.indexOf('streetview')>0){
      this.streetView=true;

      if (!this.panorama){
        this.initStreetView(    );
        this.myPosition={x:this._appData.instagramUser.position.x,y:this._appData.instagramUser.position.y};
      }
      else{
        $('#streetViewDesk').css('visibility','visible')
        $('#matterportViewDesk').css('visibility','hidden')
        $('#youtubeViewDesk').css('visibility','hidden')

        let myx=this._appData.instagramUser.position.x;
        let oldx=this.myPosition.x;
        
        if (myx-oldx>1){
          let t=myx-oldx
          for (let x=0;x<t;x++){
            this.moveForward();
          }
          this.myPosition={x:this._appData.instagramUser.position.x,y:this._appData.instagramUser.position.y};
        }
        else if (oldx-myx>1){
       //W   this.moveBackward();
          this.myPosition={x:this._appData.instagramUser.position.x,y:this._appData.instagramUser.position.y};
        }
      }
    }
    else if (this._appData.stream.length==0){

    }
    else{
        this.youtube=true;
        this.youtubeLink=this._appData.stream
        $('#streetViewDesk').css('visibility','hidden')
        $('#matterportViewDesk').css('visibility','hidden')
        $('#youtubeViewDesk').css('visibility','visible')
        $('#youtubeViewDesk').css('height','100%')


    }


      //part 2: Decide if it should be shown, the audio etc.
      if (this._appData.selectedItem){
        //there is a video item close by
        let distance=this._appData.selectedItem.distance//maximum distance from item
        let dx=this._appData.selectedItem.dx
        let dy=this._appData.selectedItem.dy
        let d=dx>dy ? dx : dy //d has the closer
        let volume=100*(distance-d)/distance
        this.setGameWatchingVideo('unMute',[])
        this.setGameWatchingVideo('setVolume',[volume])
        if (volume<5){
          this._appData.selectedItem=null;
          this._appData.stream=null
        }
        if (volume>80 || d<=2){
          this.showScreen();
        }
      }
  }
  public fixMuteYoutube(){
    this.setGameWatchingVideo('setVolume',[10])

//    this.setGameWatchingVideo('mute',[])
  }

  public difference(link) {
    return Math.abs(this.panorama.pov.heading%360 - link.heading);
  }
  
  public moveForward() {
    var curr;
    if (this.panorama.links){
      for(let i=0; i < this.panorama.links.length; i++) {
        var differ = this.difference(this.panorama.links[i]);
        if(curr == undefined) {
          curr = this.panorama.links[i];
        }
    
        if(this.difference(curr) > this.difference(this.panorama.links[i])) {
          curr = curr = this.panorama.links[i];
        }
      }
      this.panorama.setPano(curr.pano);
  
    }
  }
  public moveBackward() {
    var curr;
    if (this.panorama.links){
      for(let i=this.panorama.links.length; i >0 ; i--) {
        var differ = this.difference(this.panorama.links[i]);
        if(curr == undefined) {
          curr = this.panorama.links[i];
        }
    
        if(this.difference(curr) < this.difference(this.panorama.links[i])) {
          curr = curr = this.panorama.links[i];
        }
      }
      this.panorama.setPano(curr.pano);
  
    }
  }
  public muteYoutube(){
    this.setGameWatchingVideo('setVolume',[10])
  }
  public alterVolume(active){

    if (active || this.setVolume){
      this.setVolume=true;
      this.iframeVolume=0.2//this.sliderVolume;
    }
    this.setGameWatchingVideo('setVolume',0)
  }
public setGameWatchingVideo(func,args){
    //"unMute"
    //"playVideo"
    //setVolume, args

      if (!args) args=0;
      let iframe= document.getElementById('youtubeViewDesk');
      if (iframe){
        iframe['contentWindow'].postMessage(JSON.stringify({
          'event': 'command',
          'func': func,
          'args': args
        }), "*");

      }

}


}


// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/youtube-component/youtube.component.ts